import { Container } from 'hypo-container';

import { HttpTransport } from '@estee/elc-http-transport';
import { getDecorators } from '@estee/elc-service';

import { AccountOverlay } from '~domain/entities/AccountOverlay';
import { Config } from '~domain/entities/Config';
import AccountSidebarController from '~exported/account-sidebar/AccountSidebarController';
import { AccountRepository } from '~repositories/AccountRepository';
import { ConfigRepository } from '~repositories/ConfigRepository';

import { AccountService } from './AccountService';
import { ServiceBusController } from './ServiceBusController';

export const diContainer = new Container();

export const serviceNames = {
    accountOverlay: 'ACCOUNT_OVERLAY',
    accountRepository: 'ACCOUNT_REPOSITORY',
    accountService: 'ACCOUNT_SERVICE',
    accountSidebarViewController: 'ACCOUNT_SIDEBAR_VIEW_CONTROLLER',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    httpTransport: 'HTTP_TRANSPORT',
    serviceBusController: 'SERVICE_BUS_CONTROLLER'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: any) => {
    diContainer.appConfig = configJSON;
};

diContainer
    .register(serviceNames.config, (c) => new Config(c.config))
    .register(serviceNames.httpTransport, (c) => new HttpTransport())
    .register(serviceNames.serviceBusController, (c) => new ServiceBusController())
    .register(serviceNames.accountOverlay, (c) => new AccountOverlay())
    .register(serviceNames.accountRepository, (c) => new AccountRepository())
    .register(
        serviceNames.accountSidebarViewController,
        (c) =>
            new AccountSidebarController({
                accountOverlay: c.get(serviceNames.accountOverlay),
                accountRepository: c.get(serviceNames.accountRepository)
            })
    )
    .register(serviceNames.configRepository, (c) => {
        const config = {
            entity: c.get(serviceNames.config)
        };

        return new ConfigRepository(config);
    })
    .register(
        serviceNames.accountService,
        (c) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            new AccountService((config: any) => {
                setConfig(config);

                return c.get(serviceNames.serviceBusController);
            })
    );

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
